export const circleGraphConfig = {
  reduceCUAction: {
    title: 'cu-titleText',
    subTitle: 'cu-subTitleText',
  },
  rebalanceCU: {
    title: 'rebalance-cu-titleText',
    subTitle: 'rebalance-cu-subTitleText',
  },
  newCardScoreIncrease: {
    title: 'ncsi-titleText',
    subTitle: 'ncsi-subTitleText',
  },
  newCardScoreOvertime: {
    title: 'ncso-titleText',
    subTitle: 'ncso-subTitleText',
  },
};
